import $ from 'jquery';

$(document).ready(function () {
    function delay(fn, ms) {
        let timer = 0;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(fn.bind(this, ...args), ms || 0);
        };
    }

    $.fn.nthParent = function (n) {
        let p = this;
        for (let i = 0; i < n; i++) p = p.parent();
        return p;
    };

    $.fn.blockDiv = function (is_icon = false, data_org_icon = false) {
        return this.each(function () {
            let div = $(this),
                icon = div.find('i'),
                icon_text = icon.text();

            if (is_icon) {
                icon.addClass('ib-spin').text('loop');

                if (data_org_icon) {
                    icon.attr('data-org-icon', icon_text);
                }
            } else {
                // eslint-disable-next-line no-undef
                div.append(ideabox_object.spinner);
                div.addClass('loading-div');
            }
        });
    };

    $.fn.unBlockDiv = function (is_icon = false, data_org_icon = false) {
        return this.each(function () {
            let div = $(this),
                icon = div.find('i'),
                org_text = icon.data('org-icon');

            div.removeClass('loading-div');

            if (is_icon) {
                icon.removeClass('ib-spin');

                if (data_org_icon) {
                    icon.text(org_text);
                }
            }

            div.find('.ib-spinner').remove();
        });
    };

    let response_message = function (alert_form, type, msg, duration = 3000) {
        let typeClass = type ? 'success' : 'danger',
            alert = $(
                '<div class="alert alert-' +
                    typeClass +
                    '" role="alert"><span class="alert-text">' +
                    msg +
                    '</span></div>'
            );

        alert_form.find('.alert').remove();
        alert.prependTo(alert_form);

        setTimeout(function () {
            alert_form.find('.alert').remove();
        }, duration);
    };

    $(document).on('click', '.article-emoticons button', function (e) {
        e.preventDefault();
        let button = $(this),
            spinner = button.next('span'),
            spinner_html = spinner.html(),
            wrapper = button.nthParent(5).find('.article-emoticons'),
            buttons = wrapper.find('.article-emoticons button'),
            type = button.data('type'),
            data = {
                action: 'ideabox_do_emoticon',
                // eslint-disable-next-line no-undef
                nonce: ideabox_object.ideabox_nonce,
                type: type,
                id: wrapper.data('id'),
            };

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: data,
            dataType: 'json',
            beforeSend: function () {
                buttons.attr('disabled', true);
                wrapper.addClass('loading');
                spinner.html('<i class="material-icons mi-spin">sync</i>');
            },
            success: function (response) {
                if (!response.success) {
                    wrapper.attr('aria-label', response.data.message);
                    setTimeout(function () {
                        wrapper.removeAttr('aria-label');
                    }, 2000);
                    spinner.html(spinner_html);
                }

                if (response.success) {
                    spinner.addClass('voted');
                    spinner.html(response.data.message);
                }

                buttons.attr('disabled', false);
                wrapper.removeClass('loading');
            },
        });
    });

    $(document).on('click', '.add-to-favorite.logged.not-added', function (e) {
        e.preventDefault();

        let button = $(this),
            icon = button.find('i'),
            filled = icon.data('filled'),
            is_mobile = button.hasClass('favorite-button-mobile'),
            data = {
                action: 'ideabox_do_add_to_fav',
                // eslint-disable-next-line no-undef
                nonce: ideabox_object.ideabox_nonce,
                id: button.data('id'),
            };

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: data,
            dataType: 'json',
            beforeSend: function () {
                button.attr('disabled', true);
                button.blockDiv(true);
            },
            success: function (response) {
                button.attr('disabled', false);

                if (response.success) {
                    button.toggleClass('not-added added');
                    icon.text(filled);
                    button.attr('aria-label', response.data.tooltip);

                    if (is_mobile) {
                        button.find('span').text(response.data.tooltip);
                    }
                }

                button.unBlockDiv(true);
            },
        });
    });

    $(document).on('click', '.add-to-favorite.logged.added', function (e) {
        e.preventDefault();

        let button = $(this),
            icon = button.find('i'),
            outline = icon.data('outline'),
            is_mobile = button.hasClass('favorite-button-mobile'),
            data = {
                action: 'ideabox_do_remove_from_fav',
                // eslint-disable-next-line no-undef
                nonce: ideabox_object.ideabox_nonce,
                id: button.data('id'),
            };

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: data,
            dataType: 'json',
            beforeSend: function () {
                button.attr('disabled', true);
                button.blockDiv(true);
            },
            success: function (response) {
                button.attr('disabled', false);

                if (response.success) {
                    button.toggleClass('not-added added');
                    icon.text(outline);
                    button.attr('aria-label', response.data.tooltip);
                }

                if (is_mobile) {
                    button.find('span').text(response.data.tooltip);
                }

                button.unBlockDiv(true);
            },
        });
    });

    $('.comment-vote').on('click', function (e) {
        e.preventDefault();

        let button = $(this),
            count = button.find('.vote-count'),
            count_text = count.find('span'),
            type = button.data('type'),
            data = {
                action: 'ideabox_do_comment_vote',
                // eslint-disable-next-line no-undef
                nonce: ideabox_object.ideabox_nonce,
                type: type,
                id: button.data('id'),
            };

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: data,
            dataType: 'json',
            beforeSend: function () {
                button.attr('disabled', true);
                button.blockDiv(true, true);
            },
            success: function (response) {
                button.attr('disabled', false);

                if (response.success) {
                    count_text.text(response.data.count);
                    $('#comment-' + response.data.id)
                        .find('button[data-type="' + type + '"]')
                        .find('.vote-count span')
                        .text(response.data.count);
                }

                if (!response.success) {
                    button.attr('aria-label', response.data.message);
                    setTimeout(function () {
                        button.removeAttr('aria-label');
                    }, 2000);
                }
            },
            complete: function () {
                button.unBlockDiv(true, true);
            },
        });
    });

    $(document).on('click', '.remove-feed-fav', function (e) {
        e.preventDefault();

        let button = $(this),
            id = button.data('id'),
            wrapper = $('.favorite-posts-main'),
            data = {
                id: id,
                // eslint-disable-next-line no-undef
                nonce: ideabox_object.ideabox_nonce,
                action: 'ideabox_do_feed_remove_from_fav',
            };

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: data,
            dataType: 'json',
            beforeSend: function () {
                button.attr('disabled', true);
                wrapper.blockDiv();
            },
            success: function (response) {
                if (response.success) {
                    wrapper.load(location.href + ' .favorite-posts-main');
                }
            },
            complete: function () {
                button.attr('disabled', false);
                wrapper.unBlockDiv();
            },
        });
    });

    $('.modal-login-form').on('submit', function (e) {
        e.preventDefault();

        let button = $(this).find('button[type="submit"]'),
            responseHtml = $(this).parent().find('.inline-response'),
            form = $(this);

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: $(this).serialize() + '&action=ideabox_do_modal_login',
            dataType: 'json',
            beforeSend: function () {
                responseHtml.html('');
                button.attr('disabled', true);
                form.blockDiv();
            },
            success: function (response) {
                response_message(form, response.success, response.data.message);

                if (response.success) {
                    setTimeout(function () {
                        window.location.reload();
                    }, 3000);
                }

                if (
                    // eslint-disable-next-line no-undef
                    ideabox_object.is_recaptcha_active === 'true' &&
                    !response.success
                ) {
                    // eslint-disable-next-line no-undef
                    grecaptcha.reset(ib_login_rc);
                }
            },
            complete: function () {
                button.attr('disabled', false);
                form.unBlockDiv();
            },
        });
    });

    $('.modal-register-form').on('submit', function (e) {
        e.preventDefault();

        let button = $(this).find('button[type="submit"]'),
            responseHtml = $(this).parent().find('.inline-response'),
            form = $(this);

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: $(this).serialize() + '&action=ideabox_do_modal_register',
            dataType: 'json',
            beforeSend: function () {
                responseHtml.html('');
                button.attr('disabled', true);
                form.blockDiv();
            },
            success: function (response) {
                response_message(form, response.success, response.data.message);

                if (response.success) {
                    setTimeout(function () {
                        window.location.reload();
                    }, 3000);
                }

                if (
                    // eslint-disable-next-line no-undef
                    ideabox_object.is_recaptcha_active === 'true' &&
                    !response.success
                ) {
                    // eslint-disable-next-line no-undef
                    grecaptcha.reset(ib_register_rc);
                }
            },
            complete: function () {
                button.attr('disabled', false);
                form.unBlockDiv();
            },
        });
    });

    $('.modal-profile-form').on('submit', function (e) {
        e.preventDefault();

        let form = $(this),
            button = form.find('button[type="submit"]'),
            responseHtml = form.parent().find('.inline-response');

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: form.serialize() + '&action=ideabox_do_modal_profile',
            dataType: 'json',
            beforeSend: function () {
                responseHtml.html('');
                form.blockDiv();
                button.attr('disabled', true);
            },
            success: function (response) {
                response_message(form, response.success, response.data.message);
            },
            complete: function () {
                form.unBlockDiv();
                button.attr('disabled', false);
            },
        });
    });

    $('.modal-password-form').on('submit', function (e) {
        e.preventDefault();

        let form = $(this),
            button = form.find('button[type="submit"]'),
            responseHtml = form.parent().find('.inline-response');

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ideabox_object.ajax_url,
            data: form.serialize() + '&action=ideabox_do_modal_password',
            dataType: 'json',
            beforeSend: function () {
                responseHtml.html('');
                form.blockDiv();
                button.attr('disabled', true);
            },
            success: function (response) {
                response_message(form, response.success, response.data.message);
            },
            complete: function () {
                form.unBlockDiv();
                button.attr('disabled', false);
            },
        });
    });

    $('.ib-ajax-search input').on(
        'input',
        delay(function () {
            let wrapper = $('.search-input-wrapper'),
                resultsWrapper = $('.ajax-results'),
                results = resultsWrapper.find('.results'),
                count = resultsWrapper.find('.count'),
                input = $(this),
                data = {
                    action: 'ideabox_ajax_search',
                    keyword: input.val(),
                    // eslint-disable-next-line no-undef
                    nonce: ideabox_object.ideabox_nonce,
                };

            if (input.val() === '') {
                resultsWrapper.hide();
                return;
            }

            $.ajax({
                // eslint-disable-next-line no-undef
                url: ideabox_object.ajax_url,
                data: data,
                type: 'POST',
                dataType: 'json',
                beforeSend: function () {
                    wrapper.blockDiv(true, true);
                    resultsWrapper.blockDiv();
                },
                success: function (response) {
                    resultsWrapper.show();
                    results.html(response.data.result);
                    count.html(response.data.count);
                },
                complete: function () {
                    wrapper.unBlockDiv(true, true);
                    resultsWrapper.unBlockDiv();
                },
            });
        }, 300)
    );
});
